export default __webpack_public_path__ + "static/media/electric-forest.18c158b8.png";